module.exports = __webpack_public_path__ + "static/media/fillopacity-icon.c9d978aa.svg";